<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const { t } = useI18n({});
const store = useStore();
const isPartnerLevelPlatinum = computed(() => store.state.partnerProfile.profileData.level.toLowerCase() === 'platinum');
const companyName = computed(() => store.state.partnerProfile.profileData.name);

const descriptionItems = [
  "sap.gold.partner.description.item.a",
  "sap.gold.partner.description.item.b",
  "sap.gold.partner.description.item.c",
];

function keyCategoriesDescriptionText() {
  const company = { company: companyName.value };
  return isPartnerLevelPlatinum.value
    ? t("sap.partner.platinum.key.categ.text", company)
    : t("sap.partner.key.categ.text");
}
</script>

<template>
  <p :class="isPartnerLevelPlatinum ? 'mt-10' : ''" automation-id="partnerLevelKeyGategories-description">
    {{ keyCategoriesDescriptionText() }}
  </p>
  <ul class="list-disc pl-5 mb-8" automation-id="partnerLevelKeyGategoriesList">
    <li v-for="item in descriptionItems" :key="item" v-html="t(item)" />
  </ul>
</template>
